/**
 * @typedef {object} AdSettings
 * @property {AdPosition[]} positions
 * @property {string} unit
 */

/**
 *
 * @param {AdSettings} adSettings
 * @param {string[]} keywords
 * @param {string} url
 */
const getPageTargetingArguments = ({ adSettings, keywords, url }) => {
  const result = {};

  adSettings.unit.split('/').forEach((value, index) => {
    result[`s${index + 1}`] = value;
  });

  result.pgtype = 'article';

  result.meta = keywords.map((keyword) => keyword.trim());

  result.pageurl = url
    .replace(/^https?:\/\/apps.bostonglobe.com/, '')
    .replace(/\//g, '_');

  return result;
};

export default getPageTargetingArguments;
